import { Link } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";
import { useState, useEffect } from "react";
import Legal from "./legal.js";
import Backup from "./backup.js";
import Header from "../../header.js";
import Navvbar from "../../Navvbar.js";
import General from "./general";
import Preferences from "./preferences.js";
import Permissions from "./permissions";
import Instructions from "./instructions";
import PinSetup from "./pin/PinSetup.jsx";
import "./setting.css";

const DetailTabs = () => {
  const [activeTab, setActiveTab] = useState("General");
  const [userLabId, setUserLabId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUserLabId = localStorage.getItem("userLabId");

    if (
      storedUserLabId &&
      storedUserLabId !== "undefined" &&
      storedUserLabId !== "null" &&
      storedUserLabId !== ""
    ) {
      setUserLabId(storedUserLabId);
    }

    setLoading(false);
  }, []);

  const handleTabSelect = (key) => {
    // Disabled tabs ko ignore karo
    if (
      key === "Permissions" ||
      key === "Instructions" ||
      key === "Legal" ||
      key === "Backups"
    ) {
      return;
    }
    setActiveTab(key);
  };

  if (loading) {
    return (
      <>
        <Header />
        <Navvbar />
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          Loading...
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <Navvbar />
      <br />
      <div className="settings-page-wrapper">
        <div className="settings-layout">
          <div className="settings-sidebar">
            <h2>Settings</h2>
            <div className="settings-sidebar-list">
              <Link to="/Tabs" className="settings-sidebar-link">
                Lab Details
              </Link>

              <span className="settings-sidebar-disabled">Store</span>

              <Link to="/users" className="settings-sidebar-link">
                Users
              </Link>

              <span className="settings-sidebar-disabled">
                Permission Groups
              </span>

              <Link to="/accountTable" className="settings-sidebar-link">
                Accounts
              </Link>

              <Link to="/financeOwerview" className="settings-sidebar-link">
                Finances
              </Link>

              <Link to="/caseSetting" className="settings-sidebar-link">
                Case Settings
              </Link>
            </div>
          </div>

          <div className="settings-content">
            <h2>Lab Details</h2>
            <Tabs
              activeKey={activeTab}
              onSelect={handleTabSelect}
              id="uncontrolled-tab-example"
              className="mb-3 settings-tabs"
            >
              <Tab
                eventKey="General"
                title={
                  <div className={activeTab === "General" ? "settings-tab-active" : ""}>
                    General
                  </div>
                }
              >
                <General />
              </Tab>
              <Tab
                eventKey="Preferences"
                title={
                  <div className={activeTab === "Preferences" ? "settings-tab-active" : ""}>
                    Preferences
                  </div>
                }
              >
                <Preferences />
              </Tab>
              <Tab
                eventKey="Permissions"
                disabled
                title={
                  <div className="settings-tab-disabled">
                    Permissions
                  </div>
                }
              >
                <Permissions />
              </Tab>
              <Tab
                eventKey="Instructions"
                disabled
                title={
                  <div className="settings-tab-disabled">
                    Instructions
                  </div>
                }
              >
                <Instructions />
              </Tab>
              <Tab
                eventKey="Legal"
                disabled
                title={
                  <div className="settings-tab-disabled">
                    Legal
                  </div>
                }
              >
                <Legal />
              </Tab>
              <Tab
                eventKey="Backups"
                disabled
                title={
                  <div className="settings-tab-disabled">
                    Backups
                  </div>
                }
              >
                <Backup />
              </Tab>
              <Tab
                eventKey="PinSecurity"
                title={
                  <div className={activeTab === "PinSecurity" ? "settings-tab-active" : ""}>
                    PIN Security
                  </div>
                }
              >
                {(() => {
                  if (userLabId) {
                    return <PinSetup userLabId={userLabId} />;
                  } else {
                    return (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "40px",
                          color: "#666",
                          backgroundColor: "#f9f9f9",
                          borderRadius: "8px",
                          margin: "20px",
                        }}
                      >
                        <p>⚠️ Please log in to access PIN settings</p>
                        <p style={{ fontSize: "14px", color: "#999", marginTop: "10px" }}>
                          userLabId state value: {userLabId || "null"}
                        </p>
                        <p style={{ fontSize: "14px", color: "#999", marginTop: "5px" }}>
                          localStorage userLabId: {localStorage.getItem("userLabId") || "NOT FOUND"}
                        </p>
                        <p style={{ fontSize: "12px", color: "#999", marginTop: "5px" }}>
                          userRole: {localStorage.getItem("userRole") || "NOT FOUND"}
                        </p>
                        <p style={{ fontSize: "12px", color: "#999", marginTop: "5px" }}>
                          userEmail: {localStorage.getItem("userEmail") || "NOT FOUND"}
                        </p>
                        <button
                          onClick={() => {
                            const labId = localStorage.getItem("userLabId");
                            if (labId) {
                              setUserLabId(labId);
                            }
                          }}
                          style={{
                            color: "#004aad",
                            textDecoration: "none",
                            fontWeight: "bold",
                            display: "inline-block",
                            marginTop: "10px",
                            padding: "8px 20px",
                            border: "1px solid #004aad",
                            borderRadius: "5px",
                            background: "white",
                            cursor: "pointer",
                          }}
                        >
                          Refresh PIN Status
                        </button>
                        <Link
                          to="/login"
                          style={{
                            color: "#004aad",
                            textDecoration: "none",
                            fontWeight: "bold",
                            display: "inline-block",
                            marginTop: "10px",
                            padding: "8px 20px",
                            border: "1px solid #004aad",
                            borderRadius: "5px",
                            marginLeft: "10px",
                          }}
                        >
                          Go to Login
                        </Link>
                      </div>
                    );
                  }
                })()}
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailTabs;